//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import {Form, FormItem, Input, Divider} from 'element-ui'
import CyMobileLayout from '../../../components/mobile/CyMobileLayout'
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Divider)
export default {
  name: 'StockOutRecordDetail',
  components: {
    CyMobileLayout
  },
  data () {
    return {
      planId: this.$route.query.planId,
      planInfo: {},
      recordList: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init: function () {
      let that = this
      let url = '/wms/stockout/detail/getStockOutRecord'
      that.$axiosWeb.post(url, null, {params: {planId: that.planId}}).then(function (res) {
        if (res.meta.success) {
          that.planInfo = res.data.planInfo
          that.recordList = res.data.recordList
        } else {
          that.$Msgbox.alert(res.meta.message, '出库记录信息获取失败！')
        }
      })
    },

    stockOutFinish: function () {
      let that = this
      let url = '/wms/stockout/confirm/stockOutFinish'
      that.$axiosWeb.post(url, null, {params: {planId: that.planId}}).then(function (res) {
        if (res.meta.success) {
          that.$Msgbox.alert('出库完成')
          location.href = '/wx/wms/stockOutPlanList'
        } else {
          that.$Msgbox.alert(res.meta.message, '出库失败')
        }
      })
    },
    goBack: function () {
      let that = this
      location.href = '/wx/wms/stockOutConfirm?planId=' + that.planId
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/wms/stockout/StockOutRecordDetail.vue